import { FileText, Film, Music, Download, Trash2, Share2 } from "lucide-react";
import { formatBytes } from "@/lib/format";

export function AttachmentView({ file, url, onRemove, onShare, testId }) {
  const ct = file.content_type || "";
  const cat = file.category || (ct.startsWith("image/") ? "image" : ct.startsWith("audio/") ? "audio" : ct.startsWith("video/") ? "video" : "document");
  if (cat === "image") {
    return (
      <div className="relative" data-testid={testId}>
        <a href={url} target="_blank" rel="noreferrer"><img src={url} alt={file.filename} className="h-40 w-full rounded-2xl object-cover" /></a>
        <div className="absolute right-2 top-2 flex gap-1.5">
          {onShare && <button onClick={onShare} className="rounded-full bg-black/50 p-1.5 text-white" aria-label="Compartilhar arquivo" data-testid={`${testId}-share`}><Share2 size={14} /></button>}
          {onRemove && <button onClick={onRemove} className="rounded-full bg-black/50 p-1.5 text-white" aria-label="Remover anexo" data-testid={`${testId}-remove`}><Trash2 size={14} /></button>}
        </div>
      </div>
    );
  }
  if (cat === "video") {
    return (
      <div className="ga-card overflow-hidden" data-testid={testId}>
        <video src={url} controls playsInline className="max-h-64 w-full bg-black" />
        <Footer file={file} url={url} onRemove={onRemove} onShare={onShare} testId={testId} icon={Film} />
      </div>
    );
  }
  if (cat === "audio") {
    return (
      <div className="ga-card p-3" data-testid={testId}>
        <audio src={url} controls className="w-full" />
        <Footer file={file} url={url} onRemove={onRemove} onShare={onShare} testId={testId} icon={Music} />
      </div>
    );
  }
  return (
    <div className="ga-card p-3" data-testid={testId}>
      <Footer file={file} url={url} onRemove={onRemove} onShare={onShare} testId={testId} icon={FileText} />
    </div>
  );
}

function Footer({ file, url, onRemove, onShare, testId, icon: Icon }) {
  return (
    <div className="flex items-center gap-1.5 pt-2 text-sm">
      <Icon size={18} style={{ color: "#0A6373" }} className="shrink-0" />
      <span className="min-w-0 flex-1 truncate font-medium">{file.filename}</span>
      {file.size ? <span className="ga-muted shrink-0 text-[11px]">{formatBytes(file.size)}</span> : null}
      {onShare && <button onClick={onShare} className="shrink-0 p-1.5" style={{ color: "#0A6373" }} aria-label="Compartilhar arquivo" data-testid={`${testId}-share`}><Share2 size={16} /></button>}
      <a href={url} download={file.filename} target="_blank" rel="noreferrer" className="ga-muted shrink-0 p-1.5" aria-label="Baixar" data-testid={`${testId}-download`}><Download size={16} /></a>
      {onRemove && <button onClick={onRemove} className="shrink-0 p-1.5 text-red-400" aria-label="Remover anexo" data-testid={`${testId}-remove`}><Trash2 size={16} /></button>}
    </div>
  );
}
